var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30.159,
    rx: 29.5,
    ry: 30.159,
    fill: "#28CC9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9453 33.0801H14.2891C13.9223 33.0801 13.5706 32.9311 13.3113 32.666C13.0519 32.4009 12.9062 32.0413 12.9062 31.6664C12.9062 31.2914 13.0519 30.9319 13.3113 30.6667C13.5706 30.4016 13.9223 30.2527 14.2891 30.2527H41.9453C42.3121 30.2527 42.6638 30.4016 42.9231 30.6667C43.1824 30.9319 43.3281 31.2914 43.3281 31.6664C43.3281 32.0413 43.1824 32.4009 42.9231 32.666C42.6638 32.9311 42.3121 33.0801 41.9453 33.0801Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3733 31.6664L29.9042 19.944C29.6446 19.6785 29.4987 19.3185 29.4987 18.9431C29.4987 18.5677 29.6446 18.2076 29.9042 17.9422C30.1639 17.6767 30.5161 17.5276 30.8833 17.5276C31.2505 17.5276 31.6026 17.6767 31.8623 17.9422L44.3076 30.6655C44.4364 30.7968 44.5386 30.9528 44.6083 31.1246C44.678 31.2963 44.7139 31.4804 44.7139 31.6664C44.7139 31.8523 44.678 32.0364 44.6083 32.2082C44.5386 32.3799 44.4364 32.536 44.3076 32.6673L31.8623 45.3906C31.6026 45.656 31.2505 45.8052 30.8833 45.8052C30.5161 45.8052 30.1639 45.656 29.9042 45.3906C29.6446 45.1251 29.4987 44.7651 29.4987 44.3897C29.4987 44.0143 29.6446 43.6542 29.9042 43.3888L41.3733 31.6664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/frame1.15f242bf0b6b310415225de751311d14.svg";
export { ForwardRef as ReactComponent };